export const IS_PRODUCTION_BUILD = import.meta.env.PROD;

export const ENVIRONMENT_NAME = import.meta.env.VITE_APP_ENVIRONMENT_NAME;
export const IS_PRODUCTION = import.meta.env.VITE_APP_IS_PRODUCTION === 'true';

export const APP_API_ENDPOINT = import.meta.env.VITE_APP_API_ENDPOINT || '';

export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_APP_STRIPE_PUBLIC_KEY;

export const AWS_COGNITO_REGION = import.meta.env.VITE_APP_AWS_COGNITO_REGION;
export const AWS_COGNITO_CLIENT_ID = import.meta.env.VITE_APP_AWS_COGNITO_CLIENT_ID;
export const AWS_COGNITO_ENDPOINT = import.meta.env.VITE_APP_AWS_COGNITO_ENDPOINT || undefined;

export const BUILD_VERSION = import.meta.env.VITE_APP_BUILD_VERSION;
